const listTopics = document.querySelector('.js-privacy-list')
const topics = document.querySelectorAll(
  '.policy-privacy__content .policy-privacy__text h2',
)

if (listTopics) {
  // CRIAÇÃO DOS ELEMENTOS
  topics.forEach((topic) => {
    let listElement = document.createElement('li')
    listTopics.appendChild(listElement)

    let ancorTopic = document.createElement('a')
    ancorTopic.setAttribute('href', '#')
    listElement.appendChild(ancorTopic)

    let textTopic = document.createElement('span')
    textTopic.textContent = topic.textContent
    ancorTopic.appendChild(textTopic)
  })

  const allTopics = document.querySelectorAll('.js-privacy-list li a')

  allTopics[0].classList.add('active')

  function offset(el) {
    if (document) {
      const rect = el.getBoundingClientRect()
      const scrollLeft =
        window.pageXOffset || document.documentElement.scrollLeft
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop
      return { top: rect.top + scrollTop, left: rect.left + scrollLeft }
    }
  }

  function handleScrollTop(position) {
    if (document) {
      const topics = document.querySelectorAll(
        '.policy-privacy__content .policy-privacy__text h2',
      )[position]

      window.scroll({
        behavior: 'smooth',
        left: 0,
        top: offset(topics).top - 110,
      })
    }
  }

  allTopics.forEach((item, index) => {
    item.addEventListener('click', (event) => {
      event.preventDefault()

      allTopics.forEach((all) => {
        all.classList.remove('active')
      })

      item.classList.add('active')

      handleScrollTop(index)
    })
  })
}
